export default {
  pageName: 'Custom AI Summary List',
  pageId: '25051',
  pagePath: '/opinion/AIAnalysisHub/CustomAISummary',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    // TAB切换
    SummaryType: {
      buttonId: '25051001',
    },
    // 点击报告标题进入预览页
    PreviewAnalysis: {
      buttonId: '25051002',
    },
    // 点击下载报告
    DownloadReport: {
      buttonId: '25051003',
    },
    // 点击删除
    Delete: {
      buttonId: '25051004',
    },
    // 点击修改例行设置
    EditRepeatSettings: {
      buttonId: '25051005',
    },
    // 点击查看例行设置详情
    RepeatDetailSetting: {
      buttonId: '25051006',
    },
  },
};
